import { Model } from 'pinia-orm'
import ScreenTimeEvent from './ScreenTimeEvent'

export default class Child extends Model {
  // entity is a required property for all models.
  static entity = 'Child'

  static fields() {
    return {
      id: this.uid(), // Use uuid for unique identifier
      name: this.string(''),

      // Relationships
      screenTimeEvents: this.hasMany(ScreenTimeEvent, 'childId'),
    }
  }

  declare id: string
  declare name: string
  declare screenTimeEvents: ScreenTimeEvent[] | null
}
